import { useLayoutEffect } from 'react';

export const useOnElementResize = (ref, callback) => {
  useLayoutEffect(() => {
    const currentRefValue = ref.current;

    if (currentRefValue) {
      const resizeObserver = new ResizeObserver(callback);

      resizeObserver.observe(currentRefValue);

      return () => {
        resizeObserver.unobserve(currentRefValue);
      };
    }
  }, [ref, callback]);
};
